import { render, staticRenderFns } from "./ChatReceivedAttachmentComponent.vue?vue&type=template&id=1c178ae6&"
import script from "./ChatReceivedAttachmentComponent.vue?vue&type=script&lang=js&"
export * from "./ChatReceivedAttachmentComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/lpcms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c178ae6')) {
      api.createRecord('1c178ae6', component.options)
    } else {
      api.reload('1c178ae6', component.options)
    }
    module.hot.accept("./ChatReceivedAttachmentComponent.vue?vue&type=template&id=1c178ae6&", function () {
      api.rerender('1c178ae6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/ChatReceivedAttachmentComponent.vue"
export default component.exports